import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var userDataKader = localStorage.getItem("userDataKader") ? JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader")))) : "";

var serviceName = "index";
var sliderService = {
    imageUrlBuyuk: WsProvider.resim + "/" + userDataKader["firmaKodu"] + "/buyuk/",
    imageUrlOrta: WsProvider.resim + "/" + userDataKader["firmaKodu"] + "/orta/",
    imageUrlKucuk: WsProvider.resim + "/" + userDataKader["firmaKodu"] + "/kucuk/",
    imageUrlEnKucuk: WsProvider.resim + "/" + userDataKader["firmaKodu"] + "/enkucuk/",
    path  : "https://www.kaderfood.ch/",
    bg  : "https://www.kaderfood.ch/resimler/slider.jpg",
    sliderTanimlama(oncekiSliderKodu, resim, anaBaslik, altBaslik, aciklama,link1,linkButon1,link2,linkButon2,durum,dil) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                oncekiSliderKodu: oncekiSliderKodu,
                resim: resim,
                anaBaslik: anaBaslik,
                altBaslik: altBaslik,
                aciklama: aciklama,
                linkButon1: linkButon1,
                link1: link1,
                linkButon2: linkButon2,
                link2: link2,
                durum: durum,
                dil: dil,
                serviceName: "slider",
                methodName: "sliderTanimlama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    sliderList(durum, baslangic, limit) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                durum: durum,
                baslangic: baslangic,
                limit: limit,
                serviceName: "slider",
                methodName: "sliderList"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    sliderKisaList() {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                serviceName: "slider",
                methodName: "sliderKisaList"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    sliderDetay(sliderId) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                sliderId: sliderId,
                serviceName: "slider",
                methodName: "sliderDetay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    sliderDurumGuncelle(sliderId, durum) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                sliderId: sliderId,
                durum: durum,
                serviceName: "slider",
                methodName: "sliderDurumGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    sliderGuncelle(sliderId, updateList) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                sliderId: sliderId,
                updateList: updateList,
                serviceName: "slider",
                methodName: "sliderGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

}

export default sliderService

